import get from 'lodash/get'

import {
  createResource,
  fetchCollection,
  performActionOnResource
} from './index'

import { commentSchema } from '../schemas'

export const CREATE_COMMENT_REQUEST = 'CREATE_COMMENT_REQUEST'
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS'
export const CREATE_COMMENT_FAILURE = 'CREATE_COMMENT_FAILURE'

export function createCommentForArea (areaId, data) {
  return createResource({
    url: `/areas/${areaId}/comments`,
    key: 'comment',
    schema: commentSchema,
    actions: [ CREATE_COMMENT_REQUEST, CREATE_COMMENT_SUCCESS, CREATE_COMMENT_FAILURE ],
    data,
    responseInterceptor: response => ({ ...response, areaId, commentId: `comment-${response.result}` })
  })
}

export const CREATE_WORK_ORDER_COMMENT_REQUEST = 'CREATE_WORK_ORDER_COMMENT_REQUEST'
export const CREATE_WORK_ORDER_COMMENT_SUCCESS = 'CREATE_WORK_ORDER_COMMENT_SUCCESS'
export const CREATE_WORK_ORDER_COMMENT_FAILURE = 'CREATE_WORK_ORDER_COMMENT_FAILURE'

export function createCommentForWorkOrder (workOrderId, data) {
  return createResource({
    url: `/work_orders/${workOrderId}/comments`,
    key: 'comment',
    schema: commentSchema,
    actions: [ CREATE_WORK_ORDER_COMMENT_REQUEST, CREATE_WORK_ORDER_COMMENT_SUCCESS, CREATE_WORK_ORDER_COMMENT_FAILURE ],
    data,
    responseInterceptor: response => ({ ...response, workOrderId })
  })
}

export const FETCH_WORK_ORDER_COMMENTS_REQUEST = 'FETCH_WORK_ORDER_COMMENTS_REQUEST'
export const FETCH_WORK_ORDER_COMMENTS_SUCCESS = 'FETCH_WORK_ORDER_COMMENTS_SUCCESS'
export const FETCH_WORK_ORDER_COMMENTS_FAILURE = 'FETCH_WORK_ORDER_COMMENTS_FAILURE'

export function fetchCommentsForWorkOrder (url, workOrderId, reload) {
  return fetchCollection({
    url,
    key: 'comments',
    schema: commentSchema,
    actions: [ FETCH_WORK_ORDER_COMMENTS_REQUEST, FETCH_WORK_ORDER_COMMENTS_SUCCESS, FETCH_WORK_ORDER_COMMENTS_FAILURE ],
    responseInterceptor: response => ({ ...response, workOrderId, reload })
  })
}

export function loadCommentsForWorkOrder (workOrderId, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = get(getState(), `pagination.commentsByWorkOrder.${workOrderId}`, {})

    if (!nextPage) {
      nextPageUrl = `/work_orders/${workOrderId}/comments`
    }

    return dispatch(fetchCommentsForWorkOrder(nextPageUrl, workOrderId, !nextPage))
  }
}

export const PIN_COMMENT_REQUEST = 'PIN_COMMENT_REQUEST'
export const PIN_COMMENT_SUCCESS = 'PIN_COMMENT_SUCCESS'
export const PIN_COMMENT_FAILURE = 'PIN_COMMENT_FAILURE'

export function pinComment (commentId) {
  return performActionOnResource({
    url: `/comments/${commentId}`,
    action: 'pin',
    key: 'comment',
    schema: commentSchema,
    actions: [ PIN_COMMENT_REQUEST, PIN_COMMENT_SUCCESS, PIN_COMMENT_FAILURE ],
    responseInterceptor: response => ({ commentId: `comment-${commentId}` })
  })
}

export const UNPIN_COMMENT_REQUEST = 'UNPIN_COMMENT_REQUEST'
export const UNPIN_COMMENT_SUCCESS = 'UNPIN_COMMENT_SUCCESS'
export const UNPIN_COMMENT_FAILURE = 'UNPIN_COMMENT_FAILURE'

export function unpinComment (commentId) {
  return performActionOnResource({
    url: `/comments/${commentId}`,
    action: 'unpin',
    key: 'comment',
    schema: commentSchema,
    actions: [ UNPIN_COMMENT_REQUEST, UNPIN_COMMENT_SUCCESS, UNPIN_COMMENT_FAILURE ],
    responseInterceptor: response => ({ commentId: `comment-${commentId}` })
  })
}

export const FETCH_ISSUE_COMMENTS_REQUEST = 'FETCH_ISSUE_COMMENTS_REQUEST'
export const FETCH_ISSUE_COMMENTS_SUCCESS = 'FETCH_ISSUE_COMMENTS_SUCCESS'
export const FETCH_ISSUE_COMMENTS_FAILURE = 'FETCH_ISSUE_COMMENTS_FAILURE'

export function fetchCommentsForIssue (url, issueId, reload) {
  return fetchCollection({
    url,
    key: 'comments',
    schema: commentSchema,
    actions: [ FETCH_ISSUE_COMMENTS_REQUEST, FETCH_ISSUE_COMMENTS_SUCCESS, FETCH_ISSUE_COMMENTS_FAILURE ],
    responseInterceptor: response => ({ ...response, issueId, reload })
  })
}

export function loadCommentsForIssue (issueId, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = get(getState(), `pagination.commentsByIssue.${issueId}`, {})

    if (!nextPage) {
      nextPageUrl = `/issues/${issueId}/comments`
    }

    return dispatch(fetchCommentsForIssue(nextPageUrl, issueId, !nextPage))
  }
}

export const CREATE_ISSUE_COMMENT_REQUEST = 'CREATE_ISSUE_COMMENT_REQUEST'
export const CREATE_ISSUE_COMMENT_SUCCESS = 'CREATE_ISSUE_COMMENT_SUCCESS'
export const CREATE_ISSUE_COMMENT_FAILURE = 'CREATE_ISSUE_COMMENT_FAILURE'

export function createCommentForIssue (issueId, data) {
  return createResource({
    url: `/issues/${issueId}/comments`,
    key: 'comment',
    schema: commentSchema,
    actions: [ CREATE_ISSUE_COMMENT_REQUEST, CREATE_ISSUE_COMMENT_SUCCESS, CREATE_ISSUE_COMMENT_FAILURE ],
    data,
    responseInterceptor: response => ({ ...response, issueId })
  })
}



// WEBPACK FOOTER //
// ./src/actions/comments.js